import React, { useEffect, useState, useCallback } from "react";
import styles from "./ToastMessage.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const icons = {
    success: "fas fa-check-circle",
    info: "fas fa-info-circle",
    warning: "fas fa-exclamation-circle",
    error: "fas fa-exclamation-circle"
};

let addToastFn;

export function showToast({ title = "", message = "", type = "info", duration = 3000 }) {
    if (addToastFn) {
        addToastFn({ id: Date.now(), title, message, type, duration });
    }
}

export default function ToastMessage() {
    const [toasts, setToasts] = useState([]);

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);

    useEffect(() => {
        addToastFn = (toast) => {
            setToasts((prev) => [...prev, toast]);
            setTimeout(() => {
                removeToast(toast.id);
            }, toast.duration + 1000);
        };
    }, [removeToast]);

    return (
        <div className={cx("toast-container")}>
            {toasts.map(({ id, title, message, type, duration }) => {
                const delay = (duration / 1000).toFixed(2);
                return (
                    <div
                        key={id}
                        className={cx("toast", `toast--${type}`)}
                        style={{
                            animation: `slideInLeft ease 0.5s, fadeOut linear 1s ${delay}s forwards`
                        }}
                    >
                        <div className={cx("toast__icon")}>
                            <i className={icons[type]}></i>
                        </div>
                        <div className={cx("toast__body")}>
                            <h3 className={cx("toast__title")}>{title}</h3>
                            <p className={cx("toast__msg")}>{message}</p>
                        </div>
                        <div className={cx("toast__close")} onClick={() => removeToast(id)}>
                            <i className="fas fa-times"></i>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
